const formWrapper = document.querySelector('.js-bolt-sf__form-wrapper');
const titlesContainer = document.querySelector('.js-bolt-sf__titles');
const titles = document.querySelectorAll('.js-bolt-sf__titles-step');
const steps = document.querySelectorAll('.js-bolt-sf__step');
const totalSteps = steps.length;
const nextButtons = document.querySelectorAll('.js-bolt-sf-next-step');
const prevButtons = document.querySelectorAll('.js-bolt-sf-prev-step');
const screenReaderHelperMsg = document.querySelector('.js-bolt-sf__sr-msg');
let currentStepIndex = 0;

// Function to scroll to the top of the .js-bolt-sf__titles container
function scrollToTitles(callback) {
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;
  const titlePosition =
    titlesContainer.getBoundingClientRect().top + window.scrollY;
  const pageHeaderOffset = document.querySelector(
    '[data-header-height]',
  ).clientHeight;
  const offsetPosition = titlePosition - pageHeaderOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: !reduceMotion ? 'smooth' : 'auto',
  });

  setTimeout(() => {
    callback();
  }, 750);
}

// Function to move the form wrapper to the next or previous step
function goToStep(index, focusOnSelected = false) {
  // stop function imidiatelly if the condition is not met
  if (index < 0 || index >= totalSteps) {
    return;
  }

  // Scroll to the title's container and then update the step
  scrollToTitles(() => {
    steps.forEach((step, i) => {
      const isIndex = i === index;
      step.classList.toggle('c-sf__step--active', isIndex);
      setTabbable(step, isIndex);

      // If we are going back, focus on the selected radio button
      if (focusOnSelected && isIndex) {
        focusOnSelectedRadio(step);
      }
    });

    // Update the current step index
    currentStepIndex = index;

    // Move the form wrapper to the new step
    const translateX = -100 * currentStepIndex;
    formWrapper.style.transform = `translateX(${translateX}%)`;

    // Update titles for steps 1, 2, 3, 4
    updateTitles(currentStepIndex);

    // Check if there are radios or checkboxes and manage next button state
    handleInputsOnStep();
    removeBtnLoader(steps[currentStepIndex]);
  });
}

// Function to focus on the selected radio button if available
function focusOnSelectedRadio(step) {
  const selectedRadio = step.querySelector('input[type="radio"]:checked');
  if (selectedRadio) {
    selectedRadio.focus();
  }
}

// Function to enable/disable focus for step elements. Might be not needed when we'll be using AJAX solution, must be checked.
function setTabbable(step, isActive) {
  const focusableElements = step.querySelectorAll(
    'input, button, select, textarea, a',
  );

  focusableElements.forEach((el) => {
    if (isActive) {
      el.removeAttribute('tabindex'); // Allow focus
    } else {
      el.setAttribute('tabindex', '-1'); // Disable focus
    }
  });
}

// Function to update the active title based on the current step index
function updateTitles(index) {
  titles.forEach((title, i) => {
    const isActiveTitle = index >= 1 && index <= 4 && i === index - 1;
    title.classList.toggle('c-sf__titles-step--active-title', isActiveTitle);
    title.setAttribute('aria-hidden', String(!isActiveTitle));
  });
}

// Function to handle checkboxes and radios on the current step
function handleInputsOnStep() {
  const step = steps[currentStepIndex];
  const inputs = step.querySelectorAll(
    'input[type="radio"], input[type="checkbox"]',
  );

  const nextButton = step.querySelector('.js-bolt-sf-next-step');

  const messageId = screenReaderHelperMsg.id;

  // If there are no checkboxes or radio buttons, keep the next button enabled
  if (!inputs.length) {
    nextButton ? nextButton.setAttribute('aria-disabled', false) : '';
    screenReaderHelperMsg.textContent = '';
    return;
  }

  // Function to enable or disable the next button based on input selections
  function updateNextButtonState() {
    const anyInputChecked = Array.from(inputs).some((input) => input.checked);

    if (anyInputChecked) {
      nextButton.removeAttribute('aria-describedby');
      nextButton.setAttribute('aria-disabled', false);
      screenReaderHelperMsg.textContent = '';
    } else {
      nextButton.setAttribute('aria-disabled', true);
      nextButton.setAttribute('aria-describedby', messageId);
      screenReaderHelperMsg.textContent =
        'Button disabled, to enable, please select an option first.';
    }
  }

  // Function to toggle the class when the radio/checkbox is :checked, so the card values can be captured at the end of the experience.
  function updateInputSelection(input) {
    // If it's a radio button, remove the selected class from all radios before adding it to the checked one
    if (input.type === 'radio') {
      inputs.forEach((radio) => radio.classList.remove('c-sf-card--selected'));
    }
    input.classList.toggle('c-sf-card--selected', input.checked);
  }

  function scrollToNextButton() {
    if (nextButton && !isElementInViewport(nextButton)) {
      const rect = nextButton.getBoundingClientRect();
      const offset = 20; // Dodatkowy margines poniżej przycisku
      const scrollPosition =
        rect.top + window.scrollY - window.innerHeight + rect.height + offset;

      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
    }
  }

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Check the initial state of inputs when the step is displayed
  updateNextButtonState();

  // Add event listeners for both checkboxes and radios
  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      scrollToNextButton();
      updateNextButtonState();
      updateInputSelection(input);
    });
  });
}

// Function to reset radio and checkboxes on the current active step
function resetInputs(step) {
  const inputs = step.querySelectorAll(
    'input[type="radio"], input[type="checkbox"]',
  );
  inputs.forEach((input) => {
    input.checked = false;
    input.classList.remove('c-sf-card--selected');
  });
}

function addBtnLoader(button) {
  button.classList.add('e-bolt-button--is-loading');
  button.setAttribute('aria-busy', true);
}

function removeBtnLoader(step) {
  const navButtons = step.querySelectorAll(
    '.js-bolt-sf-next-step, .js-bolt-sf-prev-step',
  );

  navButtons.forEach((btn) => {
    btn.classList.remove('e-bolt-button--is-loading');
    btn.setAttribute('aria-busy', false);
  });
}

// Function to change step based on the diff parameter (-1 for prev, 1 for next)
function changeStep(diff, button) {
  const isAriaDisabled = button.getAttribute('aria-disabled') === 'true';

  if (!isAriaDisabled) {
    addBtnLoader(button);

    if (diff < 0) {
      resetInputs(steps[currentStepIndex]); // Reset inputs only when moving back
    }

    setTimeout(() => {
      const newIndex = currentStepIndex + diff;
      const focusOnSelected = diff < 0; // Focus on selected radio button if going back
      goToStep(newIndex, focusOnSelected);
    }, 250); // Simulating ajax loading delay
  }
}

// Unified button functionality for both next and prev
const allButtons = [...prevButtons, ...nextButtons];

allButtons.forEach((button) => {
  button.addEventListener('click', function () {
    const diff = button.classList.contains('js-bolt-sf-prev-step') ? -1 : 1;
    changeStep(diff, button); // Call the same function for both actions
  });
});

// Initialize by showing the first step and setting it as active
goToStep(0);
